import { render } from "./ShopFilter.vue?vue&type=template&id=a263a1d4"
import script from "./ShopFilter.vue?vue&type=script&lang=js"
export * from "./ShopFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__